import React, {Component} from 'react';
import Identification from '../../Common/Identification';
import PageContainer from '../../Common/PageContainer';
import PageDescription from '../../Common/PageDescription';
import PageTitle from '../../Common/PageTitle';

class RewardsIdentificationPage extends Component {
  render() {
    return (
      <PageContainer>
        <PageTitle title="게임별 혜택 설정을 위한 본인인증" data-qa="rewardsPageTitle" />
        <PageDescription>
          혜택 변경을 위해 아이핀 또는 휴대폰 인증을 통해 본인인증을 해주세요.
          <br />
          본인인증은 회원 가입시 본인과 동일한 명의로 본인인증을 진행해야 합니다.
        </PageDescription>
        <Identification nextUrl="/my-pc-bang/management/rewards" />
      </PageContainer>
    );
  }
}

export default RewardsIdentificationPage;
